import { Component, OnDestroy, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, Inject, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { asyncScheduler, fromEvent, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import { CoreLogService } from '../../../core/services/log.service';
import { SOTProductViewModel } from '../../models';
import { ISOTService } from '../../services';

export interface SingleProductDialogConfig {
  product: SOTProductViewModel;
  is_info_type: boolean;
  is_extra_product?: boolean;
  extra_product_label?: string;
  sot_service: ISOTService;
}

@Component({
  selector: 'sot-singleproductdialog',
  templateUrl: "./singleproductdialog.component.html",
  styleUrls: ["./singleproductdialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SingleProductDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  /** artikel container zum scrollen */
  @ViewChild("product_content") product_content_div: ElementRef;

  /** zeigt hinweis das man nach unten scrollen kann */
  public show_product_content_bottom_scroll: boolean;
  private _productScrollSubscription: Subscription;
  private _productResizeObserver: any; // ResizeObserver

  public product: SOTProductViewModel;
  public is_info_type: boolean;
  public is_extra_product: boolean = false;
  public extra_product_label?: string = "";
  private _sotService: ISOTService;

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , public dialogRef: MatDialogRef<SingleProductDialogComponent, any>
    , @Inject(MAT_DIALOG_DATA) public data: SingleProductDialogConfig
    , private _coreLogService: CoreLogService) {
    const me = this;
    me.show_product_content_bottom_scroll = false;
    if (!data.product) {
      me._coreLogService.error("SingleProductDialogComponent.constructor", "no data.product");
    }
    if (!data.sot_service) {
      me._coreLogService.error("SingleProductDialogComponent.constructor", "no data.sot_service");
    }
    me.product = data.product;

    me.is_info_type = data.is_info_type;
    if (data.is_extra_product) {
      me.is_extra_product = data.is_extra_product;
      me.extra_product_label = data.extra_product_label;
    }
    me._sotService = data.sot_service;
  }

  public ngOnInit(): void {
    const me = this;
    console.debug("--- sot-singleproductdialog ngOnInit");
    me.PushChanges();
  }

  public ngAfterViewInit(): void {
    console.debug("--- sot-singleproductdialog ngAfterViewInit")
    const me = this;
    // after view init, da dann die höhe bekannt ist
    const product_content_el = me.product_content_div.nativeElement;
    if (product_content_el.scrollHeight > product_content_el.offsetHeight) {
      me.show_product_content_bottom_scroll = true; // show bottom scroll initial
      me.PushChanges();
    }
    const checkProductListScroll = () => {
      // toggles show_product_content_bottom_scroll when scrolled to the bottom or not
      const at_bottom = (product_content_el.scrollTop + product_content_el.offsetHeight) >= (product_content_el.scrollHeight - 5 /*5=bottom_offset*/);
      if (at_bottom === me.show_product_content_bottom_scroll) {
        me.show_product_content_bottom_scroll = !at_bottom;
        me.PushChanges();
      }
    };
    // immer binden, da der content dynamisch ist
    // Subscribe to a throttled scrollEvent from ProductList
    me._productScrollSubscription = fromEvent(product_content_el, "scroll").pipe(
      throttleTime(50, asyncScheduler, { leading: true, trailing: true }),
    ).subscribe(() => { checkProductListScroll(); });

    // start observing for resize product_content_el // todo besser auf ein click reagieren, da es nicht jeden cahnge mitbekommt, nach max-height wird es nicht getriggert
    me._productResizeObserver = new (window as any).ResizeObserver(() => { checkProductListScroll(); });
    me._productResizeObserver.observe(product_content_el);
  }

  public ngOnDestroy(): void {
    console.debug("--- sot-singleproductdialog ngOnDestroy")
    const me = this;
    if (me._productScrollSubscription) {
      me._productScrollSubscription.unsubscribe();
    }
    if (this._productResizeObserver) {
      this._productResizeObserver.unobserve(this.product_content_div.nativeElement);
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("SingleProductDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public Close(): void {
    this.dialogRef.close();
  }

  public get isModeOne(): boolean {
    return this.data.sot_service.Accessabilty.useModeOne;
  }
  public get isModeTwo(): boolean {
    return this.data.sot_service.Accessabilty.useModeTwo;
  }

  public Add(): void {
    console.error("todo implement add") // todo momentan nicht da weil es ein info dialog ist
    this.dialogRef.close();
  }

  public setExtraProductLabel(): string {
    const me = this;
    return me.extra_product_label !== '' ? me.extra_product_label : me.product.label;
  }

}